import angular from 'angular';
import uiRouter from 'angular-ui-router';
import advertFeatureListComponent from './advertFeatureList.component';

let advertFeatureListModule = angular.module('advertFeatureList', [
  uiRouter
])

.component('advertFeatureList', advertFeatureListComponent)

.name;

export default advertFeatureListModule;
